var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 5.33333L8.25002 0.416667C8.4028 0.263889 8.59724 0.1875 8.83335 0.1875C9.06946 0.1875 9.26391 0.263889 9.41669 0.416667C9.56946 0.569444 9.64585 0.763889 9.64585 1C9.64585 1.23611 9.56946 1.43056 9.41669 1.58333L3.91669 7.08333C3.75002 7.25 3.55558 7.33333 3.33335 7.33333C3.11113 7.33333 2.91669 7.25 2.75002 7.08333L0.583354 4.91667C0.430576 4.76389 0.354187 4.56944 0.354187 4.33333C0.354187 4.09722 0.430576 3.90278 0.583354 3.75C0.736131 3.59722 0.930576 3.52083 1.16669 3.52083C1.4028 3.52083 1.59724 3.59722 1.75002 3.75L3.33335 5.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmall);
export default __webpack_public_path__ + "static/media/check_small.08c589cf914ad5482e93014328821f42.svg";
export { ForwardRef as ReactComponent };